/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticket_Pudo_DirectionsInputs */

const en_ticket_pudo_directions = /** @type {(inputs: Ticket_Pudo_DirectionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Directions`)
};

const ja_ticket_pudo_directions = /** @type {(inputs: Ticket_Pudo_DirectionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`経路`)
};

const fr_ticket_pudo_directions = /** @type {(inputs: Ticket_Pudo_DirectionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Itinéraire`)
};

const de_ticket_pudo_directions = /** @type {(inputs: Ticket_Pudo_DirectionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Route`)
};

/**
* | output |
* | --- |
* | "Directions" |
*
* @param {Ticket_Pudo_DirectionsInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const ticket_pudo_directions = /** @type {((inputs?: Ticket_Pudo_DirectionsInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticket_Pudo_DirectionsInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticket_pudo_directions(inputs)
	if (locale === "ja") return ja_ticket_pudo_directions(inputs)
	if (locale === "fr") return fr_ticket_pudo_directions(inputs)
	return de_ticket_pudo_directions(inputs)
});